import { errorStatusValidating as a, errorStatusSuccess as u, errorStatusWarning as c, errorStatusError as l } from "../css/ReoFormItem.mjs";
function g(t, n) {
  const r = Object.keys(t), s = Object.keys(n);
  return r.length === s.length && r.every((i) => {
    const e = t[i], o = n[i];
    return e === o || typeof e == "function" || typeof o == "function";
  });
}
function y(t, n, r, s = 0) {
  return {
    key: typeof t == "string" ? t : `${n}-${s}`,
    error: t,
    errorStatus: r
  };
}
const d = (t) => {
  switch (t) {
    case "error":
      return l;
    case "warning":
      return c;
    case "success":
      return u;
    case "validating":
      return a;
    default:
      return "";
  }
};
function p() {
  return {
    errors: [],
    warnings: [],
    touched: !1,
    validating: !1,
    name: [],
    validated: !1
  };
}
function h(t, n, r, s, i) {
  let e = s;
  return i !== void 0 ? e = i : r.validating ? e = "validating" : t.length ? e = "error" : n.length ? e = "warning" : r.touched && (e = "success"), e;
}
export {
  p as genEmptyMeta,
  d as getErrorClassByStatus,
  h as getStatus,
  g as isSimilarControl,
  y as toErrorEntity
};
//# sourceMappingURL=common.mjs.map
